import apiClient from '../../services/apiClient';

export default {
	namespaced: true,
	state: {
		init: false,
		dymo: {
			addressPrinter: null,
			productPrinter: null,
			returnPrinter: null,
			eanPrinter: null,
		},
	},
	getters: {
		addressPrinter(state) {
			return state.dymo.addressPrinter;
		},
		productPrinter(state) {
			return state.dymo.productPrinter;
		},
		returnPrinter(state) {
			return state.dymo.returnPrinter;
		},
		eanPrinter(state) {
			return state.dymo.eanPrinter;
		},
	},
	mutations: {
		SET_INIT(state, initState) {
			state.init = initState;
		},
		SET_DYMO_ADDRESS_PRINTER(state, printer) {
			state.dymo.addressPrinter = printer;
		},
		SET_DYMO_PRODUCT_PRINTER(state, printer) {
			state.dymo.productPrinter = printer;
		},
		SET_DYMO_RETURN_PRINTER(state, printer) {
			state.dymo.returnPrinter = printer;
		},
		SET_DYMO_EAN_PRINTER(state, printer) {
			state.dymo.eanPrinter = printer;
		},
		CLEAR_STORE(state) {
			state.init = false;
			state.dymo.addressPrinter = null;
			state.dymo.productPrinter = null;
			state.dymo.returnPrinter = null;
			state.dymo.eanPrinter = null;
		}
	},
	actions: {
		async init({commit, state}) {
			if (state.init) {
				return;
			}
			await apiClient.get('settings/dymo/get').then(response => {
				response.data.forEach(printer => {
					if (printer.type === 'address') {
						commit('SET_DYMO_ADDRESS_PRINTER', printer);
					} else if (printer.type === 'product') {
						commit('SET_DYMO_PRODUCT_PRINTER', printer);
					} else if (printer.type === 'return') {
						commit('SET_DYMO_RETURN_PRINTER', printer);
					} else if (printer.type === 'ean') {
						commit('SET_DYMO_EAN_PRINTER', printer);
					}
				});

				commit('SET_INIT', true);
			}).catch(err => {
			})
		},
		saveAddressPrinter({commit}, addressPrinter) {
			return new Promise((resolve, reject) => {
				const params = {
					type: 'address',
					postnl_port_stamp: false,
					...addressPrinter
				};

				apiClient.post('settings/dymo/set', params).then(response => {
					commit('SET_DYMO_ADDRESS_PRINTER', response.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		saveProductPrinter({commit}, ProductPrinter) {
			return new Promise((resolve, reject) => {
				const params = {
					type: 'product',
					...ProductPrinter
				};

				apiClient.post('settings/dymo/set', params).then(response => {
					commit('SET_DYMO_PRODUCT_PRINTER', response.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		saveReturnPrinter({commit}, ReturnPrinter) {
			return new Promise((resolve, reject) => {
				const params = {
					type: 'return',
					...ReturnPrinter
				};

				apiClient.post('settings/dymo/set', params).then(response => {
					commit('SET_DYMO_RETURN_PRINTER', response.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		saveEanPrinter({commit}, EanPrinter) {
			return new Promise((resolve, reject) => {
				const params = {
					type: 'ean',
					...EanPrinter
				};

				apiClient.post('settings/dymo/set', params).then(response => {
					commit('SET_DYMO_EAN_PRINTER', response.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
